var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModalClose24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E12317E7-5813-4FB7-9283-959126B04CF7_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Olerex-Pluss",
    transform: "translate(-1199.000000, -76.000000)",
    stroke: "#FFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Modal-Close_32px",
    transform: "translate(1200.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L32,32",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,32 L32,0",
    id: "Path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalClose24Px);
export default __webpack_public_path__ + "static/media/Icon_Modal-Close_24px.067e93bb631edfba7b84cb358d6fbbba.svg";
export { ForwardRef as ReactComponent };